varying vec3 vWorldNormal;
varying vec3 vViewDir;
varying vec2 vUv;
varying vec3 vLocalPos;

void main()
{
    vec4 worldPosition = modelMatrix * vec4(position, 1.0);

    // 疑似太陽の方向をワールド空間で固定するため、法線もワールド空間で扱う
    vWorldNormal = normalize(mat3(modelMatrix) * normal);
    vViewDir = normalize(cameraPosition - worldPosition.xyz);
    vUv = uv;
    // 表面模様のノイズはローカル座標で取る（UV シームと極の歪みを避ける）
    vLocalPos = position;

    gl_Position = projectionMatrix * viewMatrix * worldPosition;
}
